import { Menu, MenuItem } from "@mui/material";
import moment from "moment/moment";
import { useState } from "react";
import { Link } from "react-router-dom";
const BankCard = (props) => {
  const { authData, ProductStatusChange } = props;
  const InterestIndex = props.interestSort;
  const product = props.product;
  const Interest = product.interests[InterestIndex];
  console.log("bonus info=========", product?.activeinterest?.agentbonusinfo?.agentbonuses?.length)

  const [isExpanded, setIsExpanded] = useState(false);

  //console.log("Interest", Interest)
  let startDate = Interest?.startDate
    ? moment(Interest?.startDate).format("DD MMM YYYY").toUpperCase()
    : null;
  let endDate = Interest?.endDate
    ? moment(Interest?.endDate).format("DD MMM YYYY").toUpperCase()
    : null;
  const handleAgentBonus = (e) => {
    e.preventDefault();
    const agentData = {
      name: product.name,
      icon: product.icon,
      startDate,
      endDate,
      interest: Interest?.interest,
    };
    console.log(agentData)
    if (product?.activeinterest?.agentbonusinfo) {
      props.allAgentBonus(agentData, product?.activeinterest?.agentbonusinfo);
    }
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (e, act) => {
    //console.log("act", act)
    e.preventDefault();
    if (act === "edit") {
      props.inHouseAct(act, product.id);
    }
    else {
      props.inHouseAct(act, product.id);
    }
    setAnchorEl(null);
  };
  //console.log("PROPSSSS", product)
  return (
    <Link
      to={`/loan-products/${product.id}`}
      state={props.pagePermissions}
      className={`min-h-[290px] no-underline text-black hover:text-black focus:text-black rounded-[16px] bg-white  p-[0px_20px] w-[32%] max-[1300px]:w-[48%] max-[1200px]:w-[48%] max-[700px]:w-[100%] max-w-[100%] cus_shadow2 relative ${isExpanded ? "z-[9]" : "z-0"
        }`} >
      <div className="back-card-expand rounded-[16px] shadow-[0_4px_30px_rgba(0,0,0,0.1)] border border-[#e0e0e0]">
        <div
          className="absolute top-[-19px] right-[30px] p-[2px_8px] text-white text-[10px] rounded-[4px_4px_0_0] z-[-1]"
          style={{ backgroundColor: product?.cardheadercolor }}
        >
          {product?.cardheadertext}
        </div>
        <div className="card_head relative flex justify-between items-center">
          <div className="absolute top-[-33px] left-0 bg-white h-[58px] w-[58px] rounded-[8px]">
            <img
              src={`https://api.ohhto.com/${product.icon}`}
              alt="Bank Logo"
              className="rounded-[8px]"
              width="58"
              height="58"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </div>



          <div className="pl-[70px] flex-1">
            <div className="flex justify-between items-start">
              <span className="font-[700] text-[15px] text-gray-800 line-clamp-1">
                {product.name}
              </span>
              <div className="text-left">
                <div className="text-[22px] font-bold text-black leading-tight">
                  {Interest?.interest}%
                </div>
                {/* <div
                  className={`text-[13px] text-[#0F59F9] w-[60px] ${product?.activeinterest?.agentbonusinfo?.agentbonuses.length > 0 ? "cursor-pointer" : "cursor-default"}`}
                  onClick={handleAgentBonus}
                >
                  Bonus (
                  {product?.activeinterest?.agentbonusinfo?.agentbonuses
                    ? product.activeinterest.agentbonusinfo.agentbonuses.length
                    : 0}
                  )
                </div> */}
              </div>
            </div>
          </div>








          <div className="flex items-center">
            {(product?.inhouseProduct == 1 && authData?.is_primary == 1 &&
              product?.inhouseAgent === authData?.id
            )
              ?
              (
                <>
                  <span
                    className="cursor-pointer  ml-[15px] p-[5px]"
                    onClick={handleClick}
                  >
                    <img
                      src="/images/menu_horz.svg"
                      className="max-[450px]:hidden"
                      alt="edit"
                    />
                    <img
                      src="/images/menu_horz_white.svg"
                      className="hidden max-[450px]:block"
                      alt="edit"
                    />
                  </span>
                  <Menu
                    anchorEl={anchorEl}
                    id="bank_edit"
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                        mt: 1.5,
                        minWidth: "170px",
                        "& .MuiAvatar-root": {
                          width: 32,
                          height: 32,
                          ml: -0.5,
                          mr: 1,
                        },
                        "&:before": {
                          content: '""',
                          display: "block",
                          position: "absolute",
                          top: 0,
                          right: 14,
                          width: 10,
                          height: 10,
                          bgcolor: "background.paper",
                          transform: "translateY(-50%) rotate(45deg)",
                          zIndex: 0,
                        },
                      },
                    }}
                    transformOrigin={{ horizontal: "right", vertical: "top" }}
                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  >
                    <MenuItem
                      onClick={(e) => handleClose(e, "edit")}
                      sx={{
                        fontSize: "12px",
                        fontWeight: 500,
                        fontFamily: '"Inter", sans-serif',
                      }}
                    >
                      <img
                        src="/images/inhouse_edit.svg"
                        className="mr-[12px]"
                        alt="edit"
                      />{" "}
                      Edit Product
                    </MenuItem>
                    <MenuItem
                      onClick={(e) => {
                        ProductStatusChange(product?.id, product?.status == 1 ? 0 : 1)
                        handleClose(e, "del")
                      }}
                      sx={{
                        fontSize: "12px",
                        fontWeight: 500,
                        fontFamily: '"Inter", sans-serif',
                      }}
                    >
                      <img
                        src="/images/inhouse_inactive.svg"
                        className="mr-[12px]"
                        alt="inactive"
                      />{" "}
                      {product?.status == 1 ? "Inactive" : "Active"}
                    </MenuItem>
                  </Menu>
                </>
              ) : (

                <>
                  {product?.inhouseProduct == 1 && props?.pagePermissions?.update_permission == 1 && product?.inhouseAgent === authData?.admin_agent && (
                    <>
                      <span
                        className="cursor-pointer  ml-[15px] p-[5px]"
                        onClick={handleClick}
                      >
                        <img
                          src="/images/menu_horz.svg"
                          className="max-[450px]:hidden"
                          alt="edit"
                        />
                        <img
                          src="/images/menu_horz_white.svg"
                          className="hidden max-[450px]:block"
                          alt="edit"
                        />
                      </span>
                      <Menu
                        anchorEl={anchorEl}
                        id="bank_edit"
                        open={open}
                        onClose={handleClose}
                        onClick={handleClose}
                        PaperProps={{
                          elevation: 0,
                          sx: {
                            overflow: "visible",
                            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                            mt: 1.5,
                            minWidth: "170px",
                            "& .MuiAvatar-root": {
                              width: 32,
                              height: 32,
                              ml: -0.5,
                              mr: 1,
                            },
                            "&:before": {
                              content: '""',
                              display: "block",
                              position: "absolute",
                              top: 0,
                              right: 14,
                              width: 10,
                              height: 10,
                              bgcolor: "background.paper",
                              transform: "translateY(-50%) rotate(45deg)",
                              zIndex: 0,
                            },
                          },
                        }}
                        transformOrigin={{ horizontal: "right", vertical: "top" }}
                        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                      >
                        <MenuItem
                          onClick={(e) => handleClose(e, "edit")}
                          sx={{
                            fontSize: "12px",
                            fontWeight: 500,
                            fontFamily: '"Inter", sans-serif',
                          }}
                        >
                          <img
                            src="/images/inhouse_edit.svg"
                            className="mr-[12px]"
                            alt="edit"
                          />{" "}
                          Edit Product
                        </MenuItem>
                        <MenuItem
                          onClick={(e) => {
                            ProductStatusChange(product?.id, product?.status == 1 ? 0 : 1)
                            handleClose(e, "del")
                          }}
                          sx={{
                            fontSize: "12px",
                            fontWeight: 500,
                            fontFamily: '"Inter", sans-serif',
                          }}
                        >
                          <img
                            src="/images/inhouse_inactive.svg"
                            className="mr-[12px]"
                            alt="inactive"
                          />{" "}
                          {product?.status == 1 ? "Inactive" : "Active"}
                        </MenuItem>
                      </Menu>
                    </>
                  )}
                </>
              )}
          </div>
        </div>
        {/* {product.hasPremium || product.featured ? (
        <span className="inline-block">
          {product.hasPremium ? (
            <span className="inline-flex text-[13px] items-center border border-[#E1E1E1] gap-[0_6px] rounded-[4px] p-[4px_10px] text-[#263238] font-[500] mr-[10px]">
              <img
                src="/images/prem_icon.svg"
                className="w-[16px]"
                alt="star"
              />{" "}
              <span className="relative top-[1px]">Premium</span>
            </span>
          ) : null}
          {product.featured ? (
            <span className="inline-flex text-[13px] items-center border border-[#E1E1E1] gap-[0_6px] rounded-[4px] p-[4px_10px] text-[#263238] font-[500]">
              <img src="/images/star.svg" className="w-[16px]" alt="star" />{" "}
              <span className="relative top-[1px]">Featured</span>
            </span>
          ) : null}
        </span>
        ) : null} */}

        <div className="flex items-center gap-x-2 h-[36px]">
          {product.hasPremium ? (
            <span className="inline-flex text-[13px] items-center border border-[#E1E1E1] gap-[0_6px] rounded-[4px] p-[4px_10px] text-[#263238] font-[500] mr-[10px]">
              <img
                src="/images/prem_icon.svg"
                className="w-[16px]"
                alt="star"
              />{" "}
              <span className="relative top-[1px]">Premium</span>
            </span>
          ) : null}
          {product.featured ? (
            <span className="inline-flex text-[13px] items-center border border-[#E1E1E1] gap-[0_6px] rounded-[4px] p-[4px_10px] text-[#263238] font-[500]">
              <img src="/images/star.svg" className="w-[16px]" alt="star" />{" "}
              <span className="relative top-[1px]">Featured</span>
            </span>
          ) : null}
        </div>

        <div className="mt-2">
          {/* <div className="text-[11px] text-[#787486]">
          <p className="mb-[0]">
            {Interest?.remarks1.substring(0, 50)}
            {Interest?.remarks1.length > 50 && "..."}
          </p>
          <p className="mt-[2px] mb-[0]">
            {Interest?.remarks2.substring(0, 50)}
            {Interest?.remarks2.length > 50 && "..."}
          </p>
        </div> */}

          {/* Remarks Mapping */}


          {/* <div className="text-[11px] text-[#787486] mb-[10px]">
          {Array.isArray(Interest?.remarks) &&
            Interest.remarks.map((item, idx) => (
              <p key={idx} className="mt-[2px]">
                {item?.text ? item.text.length > 50 ? item.text.substring(0, 50) + "..." : item.text : ""}
              </p>
            ))}
        </div> */}

          <div className="flex flex-wrap gap-[5px] mb-[10px] min-h-[82px]">


            <div className="w-full text-[13px] text-[#333]">
              {Array.isArray(Interest?.remarks) && (
                <>
                  <ul className="list-disc pl-4 space-y-[4px] m-0 transition-all duration-300 ease-in-out">
                    {(isExpanded ? Interest.remarks : Interest.remarks.slice(0, 3)).map((item, idx) => (
                      <li key={idx} className="text-[12px] text-black leading-[1.4]">
                        <span className={`block ${!isExpanded ? "truncate overflow-hidden whitespace-nowrap text-ellipsis" : ""}`}
                          title={item?.text || ""} >
                          {item?.text || ""}
                        </span>
                      </li>
                    ))}
                  </ul>

                  {Interest.remarks.length > 3 && (
                    <div className="text-center">
                      {/* <span
                      onClick={() => setIsExpanded((prev) => !prev)}
                      className="text-blue-600 mt-1 inline-block cursor-pointer text-[13px] font-bold"
                    >
                      {isExpanded ? "Read less" : "See more"}
                    </span> */}
                      <span
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setIsExpanded((prev) => !prev);
                        }}
                        className="text-blue-600 mt-1 inline-block cursor-pointer text-[13px] font-bold"
                      >
                        {isExpanded ? "Read less" : "See more"}
                      </span>

                    </div>
                  )}
                </>
              )}
            </div>
          </div>


        </div>
        <p className="text-[12px] mb-[8px] flex items-center">
          <img src="/images/fi_dollar.svg" alt="calendar" className="mr-[5px]" />
          Min. Loan:{" "}
          <strong className="ml-[5px] font-[600]">
            {Interest?.minimum_loan_amount > 0
              ? "$" + parseInt(Interest?.minimum_loan_amount)
              : "No min. loan required"}{" "}
            {Interest?.admin_fee_status === "1" &&
              `else + admin fee $${parseInt(Interest?.admin_fee)}`}
          </strong>
        </p>
        <p className="text-[12px] mb-[8px] flex items-center">
          <img
            src="/images/fi_calendar.svg"
            alt="calendar"
            className="mr-[5px]"
          />
          Available from:{" "}
          <strong className="ml-[5px] font-[600]">
            {startDate}
            <span className="mx-[6px]">to</span>
            {endDate ? endDate : "Further Notice"}
          </strong>
        </p>
        <div className="flex flex-wrap items-center justify-between gap-[5px_10px]">
          <p className="text-[12px] mb-[0] flex items-center">
            <img src="/images/fi_clock.svg" alt="calendar" className="mr-[5px]" />
            Approval time:{" "}
            <strong className="ml-[5px] font-[600]">
              {product?.approvaltimeinfo?.name}
            </strong>
          </p>
          <p className="text-[12px] mb-[0] flex items-center">
            <img src="/images/fi_zap.svg" alt="calendar" className="mr-[5px]" />
            Loan to Value:{" "}
            <strong className="ml-[5px] font-[600]">
              {product?.ltvinfo?.name}
            </strong>
          </p>
        </div>
      </div>
    </Link>
  );
};

export default BankCard;
